import { useTranslation } from '../../../hooks/translations/TranslationProvider';
import { INotification, NotificationTypes } from '../../../utils/types';
import { TextField, Title } from '../../common';

const notificationKeys: Record<NotificationTypes, string> = {
    [NotificationTypes.JOIN]: 'notifications.join',
    [NotificationTypes.LEAVE]: 'notifications.leave',
    [NotificationTypes.JOIN_REQUEST]: 'notifications.join_request',
    [NotificationTypes.JOIN_REQUEST_ACCEPT]:
        'notifications.join_request_accept',
    [NotificationTypes.JOIN_REQUEST_DECLINE]:
        'notifications.join_request_decline',
    [NotificationTypes.START_VOTING_PHASE]: 'notifications.start_voting_phase',
    [NotificationTypes.CLOSE_EVENT]: 'notifications.close_event',
    [NotificationTypes.CANCEL]: 'notifications.cancel',
    [NotificationTypes.CANCELLED_BY_SYSTEM]: 'notifications.cancelledBySystem',
    [NotificationTypes.INVITATION]: 'notifications.invitation',
    [NotificationTypes.INVITATION_ACCEPT]: 'notifications.invitation_accept',
    [NotificationTypes.INVITATION_DECLINE]: 'notifications.invitation_decline',
    [NotificationTypes.FOLLOW]: 'notifications.follow',
};

const EVENT_ONLY_TYPES = new Set<NotificationTypes>([
    NotificationTypes.START_VOTING_PHASE,
    NotificationTypes.CLOSE_EVENT,
    NotificationTypes.CANCELLED_BY_SYSTEM,
]);

interface NotificationContentProps {
    notification: INotification;
}

const NotificationContent = ({ notification }: NotificationContentProps) => {
    const { t } = useTranslation();

    const isEventOnly = EVENT_ONLY_TYPES.has(notification.type);
    const shouldShowEvent =
        notification.type !== NotificationTypes.FOLLOW &&
        Boolean(notification.sportEvent?.name);
    const showEventNameFirst =
        notification.type === NotificationTypes.CANCELLED_BY_SYSTEM;

    return (
        <div className="notification-content">
            {!isEventOnly && (
                <Title size="xs" text={notification.sender.username} />
            )}
            {!isEventOnly && ' '}
            {showEventNameFirst && (
                <Title size="xs" text={`${notification.sportEvent?.name} `} />
            )}
            <TextField size="s">
                {t(notificationKeys[notification.type])}
            </TextField>
            {shouldShowEvent && !showEventNameFirst && (
                <Title size="xs" text={` ${notification.sportEvent?.name}`} />
            )}
        </div>
    );
};

export default NotificationContent;
